/**
 * <s-video-sound> — a visible sound on/off toggle for a muted, auto-playing video.
 *
 * Wraps the video. A button targets this element with commandfor and
 * command="--toggle-sound". The button holds [data-sound-off] and [data-sound-on]
 * icons and reads its labels from data-label-on / data-label-off.
 */
class SVideoSound extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    this.addEventListener('command', (event) => {
      if (event.command !== '--toggle-sound') return;
      const video = this.querySelector('video');
      if (!video) return;
      video.muted = !video.muted;
      if (!video.muted && video.paused) video.play().catch(() => {});
      this.#sync(video, event.source);
    }, { signal: this.#ac.signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #sync(video, button) {
    if (!(button instanceof HTMLElement)) return;
    const soundOn = !video.muted;
    button.setAttribute('aria-pressed', String(soundOn));
    button.setAttribute('aria-label', soundOn ? button.dataset.labelOff : button.dataset.labelOn);
    const off = button.querySelector('[data-sound-off]');
    const on = button.querySelector('[data-sound-on]');
    if (off) off.hidden = soundOn;
    if (on) on.hidden = !soundOn;
  }
}

customElements.define('s-video-sound', SVideoSound);
